module.exports = __webpack_public_path__ + "img/virtual-server.efb0551f.svg";